import type { CSSProperties, FC } from 'react';

import cn from 'classnames';

type BadgeProps = {
  label: string;
  className?: string;
  style?: CSSProperties;
};

export const Badge: FC<BadgeProps> = ({ label, className, style }) => (
  <span
    style={style}
    className={cn(
      'inline-flex max-w-[7.5rem] cursor-default items-center overflow-hidden rounded-full px-2 py-0.5 text-[11px] font-semibold leading-3 transition-colors',
      className,
    )}
  >
    <span className="min-w-0 truncate">{label}</span>
  </span>
);
